import { createFileRoute, redirect } from "@tanstack/react-router"
import { rpc } from "../lib/rpc.ts"

export const Route = createFileRoute("/$owner/$repo/")({
  async beforeLoad(opts) {
    const { context, params } = opts
    const data = await context.queryClient.ensureQueryData({
      queryKey: [{ owner: params.owner, repo: params.repo }] as const,
      async queryFn({ queryKey }) {
        const response = await rpc.repositories[":owner"][":repo"].$get({
          param: queryKey[0],
        })
        if (response.status === 404) throw Error(response.statusText)
        return await response.json()
      },
    })
    // follow redirect (RepositoryRedirect)
    if (data.owner.login !== params.owner || data.name !== params.repo)
      throw redirect({
        to: "/$owner/$repo",
        params: { owner: data.owner.login, repo: data.name },
      })
    const channel = data.channels.at(0)?.name
    if (!channel)
      throw Error(`${params.owner}/${params.repo}: no channel found`)
    throw redirect({
      to: "/$owner/$repo/~/$channel",
      params: { ...params, channel },
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <div />
}
